<template>
	<section class="com-b-wrap">
		<h1 class="com-title"><span class="bd"></span>积分明细</h1>
		<div class="t-info">{{userInfo.userName}} <span>积分余额：<span>{{userInfo.userPoint}}</span>个</span></div>
		<div class="com-table-wrap">
			<el-col :span="24" class="toolbar" style="padding-bottom: 0px; text-align: left;">
				<el-form :inline="true" :model="queryParam">
					<el-form-item label="筛选条件">
						<el-select v-model="queryParam.consumeType" placeholder="消费类型">
							<el-option v-for="item in [{value:'',label:'所有消费类型'},{value:'0',label:'赠出'},{value:'1',label:'获赠'},{value:'2',label:'其他类型'}]"
							 :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-date-picker v-model="queryParam.time" type="daterange" start-placeholder="开始时间" end-placeholder="结束时间"
						 value-format="yyyy-MM-dd" :picker-options="{shortcuts: [
					                    {text: '最近一周', onClick(picker) {
					                        const end = new Date();
					                        const start = new Date();
					                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					                        picker.$emit('pick', [start, end]);
					                      }
					                    },
					                    {text: '最近一个月', onClick(picker) {
					                        const end = new Date();
					                        const start = new Date();
					                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					                        picker.$emit('pick', [start, end]);
					                      }
					                    },
					                    { text: '最近三个月', onClick(picker) {
					                        const end = new Date();
					                        const start = new Date();
					                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					                        picker.$emit('pick', [start, end]);
					                      }
					                    }] }">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" v-on:click="queryList()">查询</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<el-table :data="pageListData" v-loading="loading" highlight-current-row style="width: 100%" size="medium"
			 row-class-name="listRow" @selection-change="handleSelectionChange">
				<el-table-column header-align="center" align="center" type="selection" width="55"></el-table-column>
				<el-table-column header-align="center" align="center" prop="userName" label="日期">
					<template slot-scope="scope">{{scope.row.pointTime | formatDateTime}}</template>
				</el-table-column>

				<el-table-column header-align="center" align="center" prop="inviteTime" label="消费详情">
					<template slot-scope="scope">{{scope.row.typeDesc }}</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="inviteTime" label="积分">
					<template slot-scope="scope">{{scope.row.point}}</template>
				</el-table-column>

			</el-table>

			<div class="pagination-block" style="text-align: right;padding: 30px;">
				<el-pagination v-if="paged.total > 0" @current-change="handleCurrentChange" @size-change="handleSizeChange" :total="paged.total"
				 :current-page.sync="paged.page" :page-size="paged.pageSize" :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper">
				</el-pagination>
			</div>


		</div>

	</section>
</template>



<script>
	import http from '@/http';


	export default {
		name: "PointHistory",
		data() {
			return {
				queryParam: {
					consumeType: '',
					timeStart: '',
					timeEnd: ''
				},
				loading: false,
				pageListData: [],
				paged: {
					total: 0,
					page: 1,
					pageSize: 10
				},
				selectItems: [],
				userId: null,
				userInfo: {
					userName: '',
					userPoint: ''
				}

			}
		},
		created: function() {
			this.userId = this.$route.query.userId;
			this.queryList()
		},
		methods: {
			handleSelectionChange: function(val) {
				this.selectItems = [];
				for (let o of val) {
					this.selectItems.push(o.userId);
				}
			},
			handleCurrentChange: function(val) {
				this.paged.page = val;
				this.queryList();
			},
			handleSizeChange: function(val) {
				this.paged.pageSize = val;
				this.queryList();
			},
			queryList: function() {
				var _this = this;
				_this.loading = true;
				var merge = require('webpack-merge');
				let obj = {
					timeStart: _this.queryParam.time ? _this.queryParam.time[0] : '',
					timeEnd: _this.queryParam.time ? _this.queryParam.time[1] : '',
					'userId': this.userId
				}
				var param = merge({}, _this.$route.query, _this.queryParam, obj, _this.paged);
				http.post(this.globalConfig.domain.backstage + "/point/queryPointHistoryByCondition", param, (response) => {
					_this.loading = false
					let result = response.data;
					if (result.success) {
						this.pageListData = result.data.listData;
						this.paged = result.data.paged;
						this.userInfo = {
							userName: result.data.userName,
							userPoint: result.data.userPoint
						}
					}
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.com-title {
		margin-bottom: 0;
	}

	.t-info {
		font-size: 14px;
		text-align: left;
		padding: 50px 50px;
		margin-bottom: 20px;
		border: 1px solid #EEEEEE;
		border-top: none;

		>span {
			margin-left: 80px;

			span {
				font-size: 30px;
				color: #00B1FF;

			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/invite/PointHistory.vue